// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'


import axios from 'axios'
import qs from 'qs';

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/en' // lang i18n
import 'element-ui/lib/theme-chalk/display.css';

import Icon from 'vue-svg-icon/Icon.vue'
Vue.component('icon', Icon)

Vue.config.productionTip = false

Vue.use(ElementUI, { locale })





  const service = axios.create({
    baseURL: 'http://a.com/service_pi/', // url = base url + request url
    //withCredentials: true, // send cookies when cross-domain requests
    timeout: 5000, // request timeout
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    transformRequest:[ (data) =>{
      if (data instanceof FormData){
        return data
      }else{
        return qs.stringify(data)
      }
    }],
  
    responseType:'json',
  
    transformResponse: [(data) =>{
      if (data.code!=1){

	this.$message.error(data.msg)
        return Promise.reject(new Error(data.msg || 'Error'))
  
      }
      return data;
    }],
  })

  Vue.prototype.$request = service




/* eslint-disable no-new */
/*
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})
*/


new Vue({
  router,
  render: h => h(App)
}).$mount('#app')


